import * as React from "react";

import { DataTable, Page, Spinner } from "src/components/common";
import { Select, Form, Tooltip } from "antd";

import DatasetAPI from "./DatasetAPI";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { Button } from "src/components/buttons";
import { AdminPermissions } from "src/common/Permissions";
import PickListContext from "src/context/pickListContext";
import moment from "moment";
import { toast } from "react-toastify";

interface IProps {
	match?: any;
	history: any;
}

interface IState {
	dataset: DatasetDTO;
	cutpoints: CutPointDTO[];
	loading: boolean;
	isLoading: boolean;
}

class OrganizationDatasetsCutpoints extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);
		this.state = {
			dataset: {},
			cutpoints: [],
			loading: false,
			isLoading: true,
		};
	}

	public componentDidMount() {
		const organizationId = this.props.match.params.organizationId;
		const datasetId = this.props.match.params.datasetId;

		const p_organizationDataset = DatasetAPI.getOrganizationDataset(
			organizationId,
			datasetId
		);

		const p_cutPoints = DatasetAPI.getCutPoints();

		Promise.all([p_organizationDataset, p_cutPoints]).then((values) => {
			const [organizationDataset, cutPoints] = values;

			this.setState({
				dataset: organizationDataset,
				cutpoints: cutPoints,
				loading: false,
				isLoading: false,
			});
		});
	}

	public render() {
		const riskLevels = this.state.cutpoints
			.map((c) => c.risk!)
			.filter(this.distinct);
		return this.state.isLoading !== false ? (
			<Spinner />
		) : (
			<PickListContext.Consumer>
				{({ getPickListItemDescription }) => (
					<Page title="Dataset Cutpoints">
						<div className="container-fluid">
							<div className="row">
								<div className="col-3 form-group">
									<label>Cutpoints</label>
									<Form.Item>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditDatasetCutpoints]}
										>
											<Select
												style={{ width: "100%" }}
												id="cutpoints"
												value={this.state.dataset.riskLevel}
												onChange={this.datasetCutPointsOnChange}
											>
												{riskLevels.map((r) => {
													return (
														<Select.Option key={r.toString()} value={r}>
															- Risk {r} -
														</Select.Option>
													);
												})}
											</Select>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
							</div>
							<DataTable
								data={this.state.cutpoints}
								columns={this.generateColumns(getPickListItemDescription)}
								filterable={false}
								showPagination={false}
								loading={this.state.loading}
								hasActions={false}
								className="mb-5 text-center"
							/>
							<AuthorizationWrapper
								type="hide"
								permissions={[AdminPermissions.EditDatasetCutpoints]}
							>
								<Button onClick={this.datasetOnSave} className="btn-primary">
									Save
								</Button>
							</AuthorizationWrapper>
						</div>
					</Page>
				)}
			</PickListContext.Consumer>
		);
	}

	private distinct = (value: number, index: number, self: number[]) => {
		return self.indexOf(value) === index;
	};

	private datasetCutPointsOnChange = (value: any) => {
		let dataset = { ...this.state.dataset };
		dataset.modifiedOn = moment().toISOString();
		dataset.riskLevel = value;
		this.setState({ dataset });
	};

	private datasetOnSave = () => {
		const { organizationId, datasetId } = this.props.match.params;
		DatasetAPI.upsertOrganizationDataset(
			organizationId,
			this.state.dataset
		).then(() => {
			toast.success("Dataset cutpoint updated");
			this.props.history.push(
				`/admin/organizations/${organizationId}/datasets/${datasetId}/cutpoints`
			);
		});
	};

	private generateColumns = (
		getPickListItemDescription: (pickListItemId: number) => string
	) => {
		return [
			{
				accessor: "id",
				show: false,
			},
			{
				Header: <Tooltip title="Risk">Risk</Tooltip>,
				accessor: "risk",
				headerStyle: { textAlign: "center" },
			},
			{
				Header: <Tooltip title="Vehicle Type">Vehicle Type</Tooltip>,
				accessor: "vehicleTypeId",
				headerStyle: { textAlign: "center" },
				Cell: (rowInfo: any) => getPickListItemDescription(rowInfo.value),
			},
			{
				Header: <Tooltip title="Vitals Pass">Vitals Pass</Tooltip>,
				accessor: "vitalsPass",
				headerStyle: { textAlign: "center" },
			},
			{
				Header: <Tooltip title="Vitals Fail">Vitals Fail</Tooltip>,
				accessor: "vitalsFail",
				headerStyle: { textAlign: "center" },
			},
			{
				Header: <Tooltip title="Cognitive Pass">Cognitive Pass</Tooltip>,
				accessor: "cognitivePass",
				headerStyle: { textAlign: "center" },
			},
			{
				Header: <Tooltip title="Cognitive Fail">Cognitive Fail</Tooltip>,
				accessor: "cognitiveFail",
				headerStyle: { textAlign: "center" },
			},
			{
				Header: <Tooltip title="Trainable Pass">Trainable Pass</Tooltip>,
				accessor: "trainablePass",
				headerStyle: { textAlign: "center" },
			},
			{
				Header: <Tooltip title="Trainable Fail">Trainable Fail</Tooltip>,
				accessor: "trainableFail",
				headerStyle: { textAlign: "center" },
			},
			{
				Header: <Tooltip title="Appraisal Pass">Appraisal Pass</Tooltip>,
				accessor: "appraisalPass",
				headerStyle: { textAlign: "center" },
			},
			{
				Header: <Tooltip title="Appraisal Fail">Appraisal Fail</Tooltip>,
				accessor: "appraisalFail",
				headerStyle: { textAlign: "center" },
			},
		];
	};
}
export default OrganizationDatasetsCutpoints;
